import { Form, Formik } from "formik";
import Title from "../../components/common/title/Title";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { postApi, putApi } from "../../services/api/globalApi";
import Input from "../../components/common/inputs/Input";
import Button from "../../components/common/button/Button";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import Select from "../../components/common/inputs/Select";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import { useRef, useState } from "react";
import Editor from "../../components/common/ck-editor/CkEditor";
import { faqValidation } from "../../utils/validations/faqValidation";

export default function FAQ() {
  const location = useLocation();
  const navigate = useNavigate();

  const { utils } = useSelector(utilsState);

  const [answer, setAnswer] = useState("");

  const formHandler = async (values, { resetForm }) => {
    if (answer.length) {
      const body = {
        ...values,
        answer,
      };
      try {
        if (location.state) {
          await putApi({
            path: `admin/faq/${location.state?.id}`,
            body: JSON.stringify(body),
          });
          successMessage("سوال با موفقیت ویرایش شد");
        } else {
          await postApi({
            path: "admin/faq",
            body: JSON.stringify(body),
          });
          successMessage("سوال با موفقیت اضافه شد");
        }
        resetForm();
        navigate("/faq-list");
      } catch (error) {
        console.error(error);
        errorMessage(error?.response?.data?.errors[0].message);
      }
    } else {
      warningMessage("لطفا پاسخ سوال را پر کنید");
    }
  };

  const copyImagesUrlModal = useRef();

  return (
    <>
      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
        <Title title={location?.state ? "ویرایش سوال" : "افزودن سوال"} />
        <Formik
          enableReinitialize
          initialValues={{
            title: location?.state?.title || "",
            part: location?.state?.part || "",
            video: location?.state?.video || "",
          }}
          validationSchema={faqValidation}
          onSubmit={formHandler}
        >
          {() => (
            <Form>
              <div className="mt-6">
                <div className="grid gap-6 mb-4 md:grid-cols-2">
                  <Input
                    name="title"
                    placeholder="عنوان"
                    label="عنوان"
                    type="text"
                  />

                  <Select name="part" placeholder="بخش" label="بخش">
                    <option value={""} selected>
                      انتخاب بخش
                    </option>
                    {utils
                      ? utils.FAQ_PART_VALUES.map((item) => {
                          return (
                            <option value={item.value}>{item?.name}</option>
                          );
                        })
                      : null}
                  </Select>
                  <Input
                    name="video"
                    placeholder="آدرس ویدئو"
                    label="آدرس ویدئو"
                    type="text"
                  />
                </div>
                <Button
                  type="button"
                  onClick={() => copyImagesUrlModal.current.showModal()}
                  text={"انتخاب عکس"}
                  color={"primary"}
                  className="mb-3"
                />

                <Editor
                  onChange={setAnswer}
                  filed={"answer"}
                  defultData={location?.state?.answer || null}
                />

                <div className="flex flex-col gap-y-2">
                  <div className="mt-6">
                    <Button
                      text={location?.state ? "ویرایش" : "افزون"}
                      type={"success"}
                    />
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <ImagesModal selectImg={false} ref={copyImagesUrlModal} />
    </>
  );
}
